import React, { useEffect, useRef } from "react";
import { FlatList, View, StyleSheet, TouchableOpacity } from "react-native";
import color from "@constants/color";
import ChevronRight from "@assets/svg/ChevronRight";
import { format } from "date-fns";
import Text from "@components/CustomText";
import { getCurrentWeek } from "../utils";

const PILL_SIZE = 59;

const DaySelector = React.memo(
  ({
    setCurrentDate,
    weekChange,
    currentDate,
    showOverall,
    setShowOverall,
  }) => {
    const perfdates = getCurrentWeek({
      currentDate,
    });

    const flatListRef = useRef(null);

    useEffect(() => {
      if (flatListRef && weekChange) {
        flatListRef.current.scrollToOffset({
          offset: 0,
          animated: true,
        });
      }
    }, [currentDate, weekChange]);

    const scrollLeft = () => {
      flatListRef.current.scrollToOffset({
        offset: 0,
        animated: true,
      });
    };

    const scrollRight = () => {
      flatListRef.current.scrollToEnd({ animated: true });
    };
    const isfuturedate = (date) => {
      return new Date(date) > new Date();
    };

    return (
      <View style={styles.weekViewContainer}>
        <View style={styles.weekViewRow}>
          <TouchableOpacity
            testID="rhd-btn"
            activeOpacity={0.8}
            style={[
              styles.item,
              {
                flex: null,
                paddingHorizontal: 6,
                marginLeft: 0,
                backgroundColor: "#F2F4FB",
              },
              showOverall && styles.selectedItem,
            ]}
            onPress={setShowOverall}
          >
            <Text
              variant="body_text_3"
              style={{ textAlign: "center", fontSize: 13 }}
            >
              {`Over \nAll`}
            </Text>
          </TouchableOpacity>
          <View style={styles.divider} />
          <TouchableOpacity
            testID="rhd-scroll-btn"
            onPress={scrollLeft}
            style={styles.chevronLeft}
          >
            <ChevronRight style={styles.chevronIconLeft} />
          </TouchableOpacity>
          <FlatList
            horizontal
            data={perfdates}
            ref={flatListRef}
            getItemLayout={(data, index) => ({
              length: PILL_SIZE,
              offset: PILL_SIZE * index,
              index,
            })}
            showsHorizontalScrollIndicator={false}
            keyExtractor={(item) => item.date}
            renderItem={({ item }) => (
              <TouchableOpacity
                testID="rhd-btn"
                activeOpacity={0.8}
                style={[
                  styles.item,
                  item.date === format(currentDate, "yyyy-MM-dd") &&
                    !showOverall &&
                    styles.selectedItem,
                ]}
                onPress={() => setCurrentDate(new Date(item.date))}
                disabled={isfuturedate(item.date)}
              >
                <Text variant="caption_4" style={styles.day}>
                  {item.day.charAt(0)}
                </Text>
                <Text variant="caption_3" style={styles.day}>
                  {item.month}
                </Text>
                <Text
                  variant="body_text_4"
                  style={[
                    styles.date,
                    isfuturedate(item.date) && {
                      color: color.lightMediumBlack,
                    },
                  ]}
                >
                  {item.date.slice(-2)}
                </Text>
              </TouchableOpacity>
            )}
          />
          <TouchableOpacity
            testID="rhd-scroll-btn"
            onPress={scrollRight}
            style={styles.chevronRight}
          >
            <ChevronRight style={styles.chevronIconRight} />
          </TouchableOpacity>
        </View>
      </View>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.currentDate === nextProps.currentDate &&
      prevProps.showOverall === nextProps.showOverall
    );
  },
);

export default DaySelector;

const styles = StyleSheet.create({
  weekViewContainer: {
    marginBottom: 4,
    backgroundColor: color.white,
    paddingHorizontal: 16,
  },
  weekViewRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  chevronLeft: {
    // left: -10,
    // position: "absolute",
    height: 40,
    width: 15,
    justifyContent: "center",
    alignItems: "flex-start",
  },
  chevronRight: {
    right: -10,
    position: "absolute",
    height: 40,
    width: 15,
    justifyContent: "center",
    alignItems: "flex-end",
  },
  chevronIconLeft: {
    height: 12,
    width: 10,
    transform: [{ rotate: "180deg" }],
  },
  chevronIconRight: {
    height: 12,
    width: 10,
  },
  item: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 12,
    paddingVertical: 8,
    borderWidth: 1,
    margin: 4,
    marginVertical: 8,
    borderRadius: 30,
    borderColor: color.lighterBlack,
    height: PILL_SIZE,
  },
  selectedItem: {
    backgroundColor: color.shadowLighter,
    borderColor: color.black,
  },
  day: {
    color: color.lightMediumBlack,
  },
  date: {
    color: color.black,
    top: -1,
  },
  divider: {
    height: "70%",
    backgroundColor: color.lighterBlack,
    marginVertical: 8,
    width: 1,
    marginHorizontal: 8,
  },
});
